import { Box } from "@mui/material";
import PageProtectedLayout from "../../components/Page/PageProtectedLayout";
import AccountLabVisits from "./AccountLabVisits";
import AddonSuggestionsSection from "./AddonSuggestionsSection";
import { useTranslation } from "../../language";


export default function LabVisitsWelcome() {
 const { t } = useTranslation();

return (

<PageProtectedLayout
    headline={t("acc_header")}
    specify={t("acc_header1")}
>

  <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center' }}>
    <AccountLabVisits />
    <AddonSuggestionsSection />
  </Box>

</PageProtectedLayout>

)}